const normalizeEntityName = (name) => (name || '').trim().toLowerCase()

const normalizeCardinality = (cardinality) => cardinality || 'one-to-many'

const groupKey = (queriedEntity, cardinality) =>
  `${normalizeEntityName(queriedEntity)}|${normalizeCardinality(cardinality)}`

const unionFields = (...fieldArrays) => {
  const byName = new Map()

  for (const fields of fieldArrays) {
    for (const field of fields || []) {
      const existing = byName.get(field.name)
      if (!existing) {
        byName.set(field.name, {
          ...field,
          fields: field.fields ? [...field.fields] : undefined
        })
        continue
      }
      if (field.fields?.length && existing.fields?.length) {
        existing.fields = unionFields(existing.fields, field.fields)
      } else if (field.fields?.length) {
        existing.fields = unionFields(field.fields)
      }
      if (field.indexed && !existing.indexed) {
        existing.indexed = true
      }
      if (field.computed && !existing.computed) {
        existing.computed = true
      }
      if (field.cardinality && !existing.cardinality) {
        existing.cardinality = field.cardinality
      }
    }
  }

  return Array.from(byName.values()).map((field) => {
    const cleaned = { ...field }
    if (!cleaned.fields) {
      delete cleaned.fields
    }

    return cleaned
  })
}

export const mergeReadModels = (readModelResponse) => {
  const groups = []
  const keyToGroup = new Map()

  for (let index = 0; index < (readModelResponse || []).length; index++) {
    const readModel = readModelResponse[index]
    if (!readModel?.readModelFields?.length) {
      continue
    }
    const hasQueriedEntity = normalizeEntityName(readModel.queriedEntity).length > 0
    const key = hasQueriedEntity
      ? groupKey(readModel.queriedEntity, readModel.cardinality)
      : `__ungrouped__${index}`

    let group = keyToGroup.get(key)
    if (!group) {
      group = {
        queriedEntity: (readModel.queriedEntity || '').trim(),
        cardinality: normalizeCardinality(readModel.cardinality),
        description: readModel.readModelDescription?.trim() || undefined,
        members: []
      }
      keyToGroup.set(key, group)
      groups.push(group)
    } else if (!group.description && readModel.readModelDescription?.trim()) {
      group.description = readModel.readModelDescription.trim()
    }
    group.members.push(readModel)
  }

  return groups.map((group) => ({
    ...group,
    mergedFields: unionFields(...group.members.map((member) => member.readModelFields))
  }))
}
